<template>
    <main>
        <section class="hero tw-grid tw-grid-cols-1 lg:tw-grid-cols-2">
            <div class="info-container">

            </div>
            <div class="form-container">
                <img src="~@/assets/img/logo.svg" alt="Clarins">
                <Form v-if="!$store.state.formSuccess" />
                <FormSuccess v-if="$store.state.formSuccess" />
            </div>
        </section>
        <section class="offers tw-py-10 lg:tw-py-16">
            <div class="tw-container">
                <h2>Vos avantages</h2>
                <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-5 tw-gap-5 lg:tw-gap-4">
                    <div class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-pb-8 lg:tw-pb-0">
                        <img src="~@/assets/img/icons/1.svg" class="tw-pb-3">
                        <p class="tw-text-black tw-text-center lg:tw-text-xl">-20% sur votre première<br> commande*</p>
                    </div>
                    <div class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-pb-8 lg:tw-pb-0">
                        <img src="~@/assets/img/icons/2.svg" class="tw-pb-3">
                        <p class="tw-text-black tw-text-center lg:tw-text-xl">Livraison Gratuite dès <br>70€ d’achat**</p>
                    </div>
                    <div class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-pb-8 lg:tw-pb-0">
                        <img src="~@/assets/img/icons/3.svg" class="tw-pb-3">
                        <p class="tw-text-black tw-text-center lg:tw-text-xl">3 échantillons <br>offerts**</p>
                    </div>
                    <div class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-pb-8 lg:tw-pb-0">
                        <img src="~@/assets/img/icons/4.svg" class="tw-pb-3">
                        <p class="tw-text-black tw-text-center lg:tw-text-xl">Cadeaux <br>exclusifs**</p>
                    </div>
                    <div class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-pb-8 lg:tw-pb-0">
                        <img src="~@/assets/img/icons/5.svg" class="tw-pb-3">
                        <p class="tw-text-black tw-text-center lg:tw-text-xl">Vos achats <br>récompensés**</p>
                    </div>
                </div>
            </div>
        </section>
        <footer>
            <div class="tw-container">
                <div>
                    <p class="tw-text-left tw-text-black tw-mb-2">* Réduction immédiate : en tant que membre, bénéficiez de 20% de réduction sur notre offre en ligne, dès le premier achat.</p>
                    <p class="tw-text-left tw-text-black tw-mb-2">** Voir conditions sur <a href="https://bnl.clarins.com/on/demandware.store/Sites-clarinsbnl-Site/fr/" target="_blank">bnl.clarins.com</a></p>
                    <p class="tw-text-left tw-text-black tw-mb-2">Les informations recueillies font l’objet d’un traitement informatique destiné à Clarins et à ses prestataires aux fins de gestion de la relation client, notamment pour vous adresser des informations personnalisées sur nos produits et services. Elles sont conservées pendant un délai de trois ans à compter de votre dernier achat ou contact. Vous disposez d’un droit d’accès, de rectification, de suppression et de portabilité des informations qui vous concernent ainsi que d’un droit d’opposition et de limitation du traitement que vous pouvez exercer en nous contactant. Pour en savoir plus, veuillez consulter notre politique de respect de la vie privée.</p>
                    <p class="tw-text-left tw-text-black">© Clarins. Tous droits réservés</p>
                </div>
            </div>
        </footer>
    </main>
</template>

<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';

main {

    section {

        &.hero {

            .info-container {
                @apply tw-bg-no-repeat tw-bg-cover tw-bg-center;
                background-image: url('~@/assets/img/hero-new-desktop.jpg');

                @screen lg {
                    @apply tw-block;
                    height: 768px;
                }
            }

            .form-container {
                @apply tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-12;

                >img {
                    @apply tw-pointer-events-none;
                    margin-bottom: 32px;

                    @screen lg {
                        width: 221.62px;
                        margin-bottom: 40px;
                    }
                }

                @screen lg {
                    @apply tw-h-full tw-pt-0;
                }
            }
        }

        &.offers {
            background-color: $light-bg;

            .tw-container {

                h2 {
                    @apply tw-text-center;
                    color: $main_color;
                    font-family: 'Clarins';
                    font-size: 26px;
                    line-height: 32px;
                    padding-bottom: 60px;

                    @screen lg {
                        font-size: 26px;
                        padding-bottom: 76px;
                    }
                }

                .tw-grid {

                    >div {

                        img {
                            @apply tw-pointer-events-none;
                        }

                        p {
                            font-family: 'Clarins';

                            @screen lg {
                                font-size: 20px;
                                line-height: 26px;
                            }
                        }
                    }
                }
            }
        }
    }

    footer {
        padding: 40px 0;

        @screen lg {
            padding: 48px 0;
        }

        line-height: 14px;
        font-size: 10px;
    }
}
</style>
